<template>
  <main>
    <MainVisual></MainVisual>
    <Concept></Concept>
    <Exhibitions></Exhibitions>
    <Greeting></Greeting>
  </main>
</template>

<script>
import TopTemplate from '@/components/Templates/Top'
import MainVisual from '@/components/Organisms/MainVisual'
import Concept from '@/components/Organisms/Concept'
import Exhibitions from '@/components/Organisms/Exhibitions'
import Greeting from '@/components/Organisms/Greeting'

export default {
  name: 'Top',
  components: {
    TopTemplate,
    MainVisual,
    Concept,
    Exhibitions,
    Greeting
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Top/index.vue